var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Flip"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m460.429 449.927-150-60c-5.695-2.278-9.429-7.793-9.429-13.927v-240c0-6.134 3.734-11.649 9.429-13.927l150-60c4.622-1.847 9.858-1.285 13.98 1.506s6.591 7.443 6.591 12.421v360c0 4.978-2.469 9.63-6.591 12.421-4.075 2.759-9.306 3.375-13.98 1.506zm-129.429-84.082 120 48v-315.69l-120 48z",
    fill: "#fff",
    strokeWidth: "10px",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m37.591 448.421c-4.122-2.791-6.591-7.443-6.591-12.421v-360c0-4.978 2.469-9.63 6.591-12.421 4.123-2.791 9.36-3.354 13.98-1.506l150 60c5.695 2.278 9.429 7.793 9.429 13.927v240c0 6.134-3.734 11.649-9.429 13.927l-150 60c-4.669 1.867-9.9 1.256-13.98-1.506zm23.409-350.266v315.689l120-48v-219.689zm135 277.845h.01z",
    fill: "#fff",
    strokeWidth: "10px",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 512c-8.284 0-15-6.716-15-15v-31c0-8.284 6.716-15 15-15s15 6.716 15 15v31c0 8.284-6.716 15-15 15z",
    fill: "#fff",
    strokeWidth: "10px",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 421c-8.284 0-15-6.716-15-15v-30c0-8.284 6.716-15 15-15s15 6.716 15 15v30c0 8.284-6.716 15-15 15z",
    fill: "#fff",
    strokeWidth: "10px",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 331c-8.284 0-15-6.716-15-15v-30c0-8.284 6.716-15 15-15s15 6.716 15 15v30c0 8.284-6.716 15-15 15z",
    fill: "#fff",
    strokeWidth: "10px",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 241c-8.284 0-15-6.716-15-15v-30c0-8.284 6.716-15 15-15s15 6.716 15 15v30c0 8.284-6.716 15-15 15z",
    fill: "#fff",
    strokeWidth: "10px",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 151c-8.284 0-15-6.716-15-15v-30c0-8.284 6.716-15 15-15s15 6.716 15 15v30c0 8.284-6.716 15-15 15z",
    fill: "#fff",
    strokeWidth: "10px",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 61c-8.284 0-15-6.716-15-15v-31c0-8.284 6.716-15 15-15s15 6.716 15 15v31c0 8.284-6.716 15-15 15z",
    fill: "#fff",
    strokeWidth: "10px",
    stroke: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlip);
export default __webpack_public_path__ + "static/media/flip.3d3449d6597f3616bf189749d0b74aaf.svg";
export { ForwardRef as ReactComponent };